<template>
	<article class='custom-call-to-action'>
    <span><h2>Custom<br>Protocol</h2></span>
    <p><strong>Can’t find what you’re looking for?</strong><br>
    Let us help you with a <a @click="openChat">custom protocol.</a></p>
	</article>
</template>

<script>
  export default {
    name: 'CalloutDocs',
    methods: {
      openChat () {
        Intercom('showNewMessage', 'I would like to inquire about custom protocols')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CalloutDocs.vue?3e7a64b0